// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselServiceOverride\VesselServiceOverrideViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// VesselServiceOverrideResponseData is the class that VesselServiceOverrideResponse serializes to/from
export interface VesselServiceOverrideResponseData {
    VesselId : number;
	
    Vessel : VesselData | null;
	
    CanEdit : boolean;
}

// VesselServiceOverrideResponseOptions is the class which may be passed to the VesselServiceOverrideResponse constructor to define optional initial data values
export interface VesselServiceOverrideResponseOptions {
    VesselId : number;
	
    Vessel? : VesselOptions | null;
	
    CanEdit? : boolean;
}

export class VesselServiceOverrideResponse {
    public VesselId : DataSignal<number>;
	
    public Vessel : DataSignal<Vessel | null>;
	
    public CanEdit : DataSignal<boolean>;

    constructor();
    constructor(data : VesselServiceOverrideResponseOptions);
    constructor(data: VesselServiceOverrideResponseOptions | null = null) {
        this.VesselId = jsonableObservable(S.value<number>(data && data.VesselId !== undefined ? data.VesselId : 0));
	    
        this.Vessel = S.value<Vessel | null>(null);
	    
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }

    static key(obj : VesselServiceOverrideResponse) {
        return obj.VesselId();
    }
    
    static dataKey(obj : VesselServiceOverrideResponseOptions) {
        return obj.VesselId;
    }

    static update(obj : VesselServiceOverrideResponse, data : VesselServiceOverrideResponseOptions) {
        S.freeze(() => {
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
	        
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/VesselServiceOverrideResponse.ts